import {css} from '@emotion/react'
import {EVENTS, logDplWithAppParams} from '../../../util/dpl'
import {getCountry} from '../../../util/getCountry'
import AppleIcon from '../../../images/app/AppleIcon.svg'
import GooglePlayIcon from '../../../images/vanish/icons/icn-play.svg'
import {getLinkData} from './qrCodeHelpers'

const translations = {
    en: {
        downloadFor: 'Download for',
        iphone: 'iPhone',
        android: 'Android',
    },
    fr: {
        downloadFor: 'Télécharger pour',
        iphone: 'iPhone',
        android: 'Android',
    },
    de: {
        downloadFor: 'Laden für',
        iphone: 'iPhone',
        android: 'Android',
    },
    nl: {
        downloadFor: 'Downloaden voor',
        iphone: 'iPhone',
        android: 'Android',
    },
}

// eslint-disable-next-line no-unused-vars
const DynamicDownloadButton = ({languageCode = 'en', experiment, os, browser, ctaType}) => {
    const text = translations[languageCode] || translations.en

    // Determine which device text, icon, and link to use
    const isAndroid = os === 'android'
    const deviceText = isAndroid ? text.android : text.iphone
    const DeviceIcon = isAndroid ? GooglePlayIcon : AppleIcon
    const linkData = getLinkData()

    return (
        <a
            href={linkData.link}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`${text.downloadFor} ${deviceText}`}
            css={css`
                display: flex;
                align-self: stretch;
                padding: 16px 15px;
                justify-content: center;
                align-items: center;
                gap: 9px;
                max-width: 350px;
                width: 100%;
                border-radius: 16px;
                background: #8519b4;
                box-shadow: 0px 0px 157.6px 0px #000;
                text-decoration: none;
                border: none;
                transition: all 0.2s ease;

                &:hover {
                    background: #7c3aed;
                    transform: translateY(-1px);
                }

                &:active {
                    transform: translateY(0);
                }
            `}
            onClick={() => {
                logDplWithAppParams(EVENTS.StartpageAppCtaClick, {
                    os,
                    country: getCountry(),
                    type: ctaType,
                    experiment,
                    source: linkData.source,
                })
            }}
        >
            <DeviceIcon
                css={css`
                    width: 20px;
                    height: 20px;
                    flex-shrink: 0;

                    path {
                        fill: #f2f3fb;
                    }
                `}
            />
            <p
                css={css`
                    color: var(--text-primary, #f2f3fb);
                    text-align: center;
                    leading-trim: both;
                    text-edge: cap;
                    font-family: Inter;
                    font-size: 18px;
                    font-style: normal;
                    font-weight: 700;
                    line-height: 30px; /* 166.667% */
                    margin-top: 3px;
                `}
            >
                {text.downloadFor} {deviceText}
            </p>
        </a>
    )
}

export default DynamicDownloadButton
